import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function FAQItem({ question, answer }: { question: string; answer: string }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-background-200/70 rounded-xl bg-background-50 overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-5 text-left hover:bg-background-100 transition-colors"
      >
        <span className="font-medium text-foreground-950 text-sm md:text-base pr-4">{question}</span>
        <i
          className={`ri-arrow-down-s-line text-foreground-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
          style={{ width: 20, height: 20 }}
        />
      </button>
      {isOpen && (
        <div className="px-5 pb-5 text-sm text-foreground-700 leading-relaxed">
          {answer}
        </div>
      )}
    </div>
  );
}

export default function FAQSection() {
  const { t } = useTranslation();

  const faqs = [
    { question: t('faq1Q'), answer: t('faq1A') },
    { question: t('faq2Q'), answer: t('faq2A') },
    { question: t('faq3Q'), answer: t('faq3A') },
    { question: t('faq4Q'), answer: t('faq4A') },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 text-center mb-10">
          {t('faqH2')}
        </h2>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </section>
  );
}